"use client"

import { LogOut, User } from "lucide-react"
import { useTranslations } from "next-intl"
import { usePostHog } from "posthog-js/react"
import { memo } from "react"

import { logout } from "@/app/[locale]/auth/actions"
import NonAuthHeader from "@/components/header/NonAuthHeader"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"

import { LanguageSelector } from "../LanguageSelector"
import SpectraLogo from "../shared/SpectraLogo"
import { useMerchantCouponRedeemer } from "@/hooks/useGlobalStore"

const MerchantCouponRedeemerHeader = memo(function MerchantCouponRedeemerHeader() {
  const t = useTranslations("customer")
  const { merchantCouponRedeemer } = useMerchantCouponRedeemer()
  const posthog = usePostHog()
  if (!merchantCouponRedeemer) {
    return <NonAuthHeader />
  }

  return (
    <div className="flex items-center justify-between px-4">
      <div className="flex items-baseline gap-4 font-glacialIndifference">
        <SpectraLogo />
      </div>
      <div className="flex items-center gap-1">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="rounded-full">
              <User className="size-5" />
              <span className="sr-only">{t("header.menu.profile")}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="[&>*]:cursor-pointer">
            <DropdownMenuItem
              className=" text-red-600"
              onClick={() => {
                posthog.reset()
                logout()
              }}
            >
              <LogOut className="mr-2 size-4" />
              <span>{t("header.menu.disconnect")}</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <LanguageSelector />
      </div>
    </div>
  )
})

export default MerchantCouponRedeemerHeader
